module.exports = __webpack_public_path__ + "static/media/cerrar.24f0cb6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/cerrar.svg
// module id = 1873
// module chunks = 0